define("shared/components/shared/video-player", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "later/utils/canvas-video-player", "later/utils/object-promise-proxy", "@glimmer/tracking", "ember-concurrency-decorators"], function (_exports, _component, _templateFactory, _object, _service, _component2, _emberConcurrency, _canvasVideoPlayer, _objectPromiseProxy, _tracking, _emberConcurrencyDecorators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/canvas-video-player",0,"later/utils/object-promise-proxy",0,"@glimmer/tracking",0,"ember-concurrency-decorators",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class={{@videoContainerClass}}
    ...attributes
    {{on "click" this.handleMediaClick}}
    {{did-insert this.handleInsert}}
    {{did-update this.handleUpdate @cropArray @trimArray @thumbOffset}}
  >
    <video
      id={{this.videoId}}
      class="video u--hide"
      preload="metadata"
      {{on "loadedmetadata" (perform this.onLoadedMeta)}}
      {{on "timeupdate" (optional @videoTimeUpdate)}}
      {{on "seeking" (set this "isSeeking" true)}}
      {{on "seeked" (set this "isSeeking" false)}}
    >
      <source src={{this.videoUrl}} type="video/mp4" />
    </video>
    {{#if @showProcessingImage}}
      <img
        class="{{this.canvasClass}} {{if this.onLoadedMeta.last.isSuccessful "u--hide" ""}}"
        src={{@postMediaItem.processingImageUrl}}
      />
    {{/if}}
    <canvas
      id={{this.canvasId}}
      class="{{this.canvasClass}} {{if this.onLoadedMeta.last.isSuccessful "" "u--hide"}}"
    ></canvas>
  </div>
  {{! Playback Seekbar }}
  {{#if @timeline}}
    <div id={{this.timelineId}} class="tMM--playback--sm eMM--playback">
      <div class="tMM--playback__progress eMM--playbackProgress"></div>
    </div>
  {{/if}}
  {{yield
    (hash
      controls=(component
        "shared/video-player/controls"
        playButtonId=this.playButtonId
        toggle=this.toggleVideo
        play=this.playVideo
        pause=this.pauseVideo
      )
      isSeeking=this.isSeeking
    )
  }}
  
  */
  {
    "id": "96j1bgzL",
    "block": "[[[11,0],[16,0,[30,1]],[17,2],[4,[38,0],[\"click\",[30,0,[\"handleMediaClick\"]]],null],[4,[38,1],[[30,0,[\"handleInsert\"]]],null],[4,[38,2],[[30,0,[\"handleUpdate\"]],[30,3],[30,4],[30,5]],null],[12],[1,\"\\n  \"],[11,\"video\"],[16,1,[30,0,[\"videoId\"]]],[24,0,\"video u--hide\"],[24,\"preload\",\"metadata\"],[4,[38,0],[\"loadedmetadata\",[28,[37,3],[[30,0,[\"onLoadedMeta\"]]],null]],null],[4,[38,0],[\"timeupdate\",[28,[37,4],[[30,6]],null]],null],[4,[38,0],[\"seeking\",[28,[37,5],[[30,0],\"isSeeking\",true],null]],null],[4,[38,0],[\"seeked\",[28,[37,5],[[30,0],\"isSeeking\",false],null]],null],[12],[1,\"\\n    \"],[10,\"source\"],[15,\"src\",[30,0,[\"videoUrl\"]]],[14,4,\"video/mp4\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[30,7],[[[1,\"    \"],[10,\"img\"],[15,0,[29,[[30,0,[\"canvasClass\"]],\" \",[52,[30,0,[\"onLoadedMeta\",\"last\",\"isSuccessful\"]],\"u--hide\",\"\"]]]],[15,\"src\",[30,8,[\"processingImageUrl\"]]],[12],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,\"canvas\"],[15,1,[30,0,[\"canvasId\"]]],[15,0,[29,[[30,0,[\"canvasClass\"]],\" \",[52,[30,0,[\"onLoadedMeta\",\"last\",\"isSuccessful\"]],\"\",\"u--hide\"]]]],[12],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[41,[30,9],[[[1,\"  \"],[10,0],[15,1,[30,0,[\"timelineId\"]]],[14,0,\"tMM--playback--sm eMM--playback\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"tMM--playback__progress eMM--playbackProgress\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[18,10,[[28,[37,8],null,[[\"controls\",\"isSeeking\"],[[50,\"shared/video-player/controls\",0,null,[[\"playButtonId\",\"toggle\",\"play\",\"pause\"],[[30,0,[\"playButtonId\"]],[30,0,[\"toggleVideo\"]],[30,0,[\"playVideo\"]],[30,0,[\"pauseVideo\"]]]]],[30,0,[\"isSeeking\"]]]]]]],[1,\"\\n\"]],[\"@videoContainerClass\",\"&attrs\",\"@cropArray\",\"@trimArray\",\"@thumbOffset\",\"@videoTimeUpdate\",\"@showProcessingImage\",\"@postMediaItem\",\"@timeline\",\"&default\"],false,[\"on\",\"did-insert\",\"did-update\",\"perform\",\"optional\",\"set\",\"if\",\"yield\",\"hash\",\"component\"]]",
    "moduleName": "shared/components/shared/video-player.hbs",
    "isStrictMode": false
  });

  let VideoPlayer = (_class = class VideoPlayer extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "errors", _descriptor, this);

      _initializerDefineProperty(this, "video", _descriptor2, this);

      _initializerDefineProperty(this, "canvas", _descriptor3, this);

      _initializerDefineProperty(this, "canvasVideoPlayer", _descriptor4, this);

      _initializerDefineProperty(this, "isLoaded", _descriptor5, this);
    }

    get mediaItem() {
      return this.args.postMediaItem.mediaItem;
    }

    get videoFrameRate() {
      var _this$mediaItem;

      return (_this$mediaItem = this.mediaItem) === null || _this$mediaItem === void 0 ? void 0 : _this$mediaItem.get('videoFrameRate');
    }

    get videoHeight() {
      return this.args.postMediaItem.height;
    }

    get videoUrl() {
      var _this$args$postMediaI, _this$args$postMediaI2;

      return (_this$args$postMediaI = this.args.postMediaItem) === null || _this$args$postMediaI === void 0 ? void 0 : (_this$args$postMediaI2 = _this$args$postMediaI.mediaItem) === null || _this$args$postMediaI2 === void 0 ? void 0 : _this$args$postMediaI2.get('videoUrl');
    }

    get videoWidth() {
      return this.args.postMediaItem.width;
    }

    get videoEndTime() {
      var _this$args$postMediaI3;

      return ((_this$args$postMediaI3 = this.args.postMediaItem.trimArray) === null || _this$args$postMediaI3 === void 0 ? void 0 : _this$args$postMediaI3.lastObject) || this.args.postMediaItem.endTime;
    }

    get videoStartTime() {
      var _this$args$postMediaI4;

      return ((_this$args$postMediaI4 = this.args.postMediaItem.trimArray) === null || _this$args$postMediaI4 === void 0 ? void 0 : _this$args$postMediaI4.firstObject) || this.args.postMediaItem.startTime;
    }

    get videoId() {
      var _this$args$videoId;

      return (_this$args$videoId = this.args.videoId) !== null && _this$args$videoId !== void 0 ? _this$args$videoId : "eVP--video--".concat(this.args.id);
    }

    get canvasId() {
      var _this$args$canvasId;

      return (_this$args$canvasId = this.args.canvasId) !== null && _this$args$canvasId !== void 0 ? _this$args$canvasId : "preview-canvas--".concat(this.args.id);
    }

    get canvasClass() {
      var _this$args$canvasClas;

      return (_this$args$canvasClas = this.args.canvasClass) !== null && _this$args$canvasClas !== void 0 ? _this$args$canvasClas : 'canvas o--media';
    }

    get timelineId() {
      return this.args.timeline ? "playback--".concat(this.args.id) : null;
    }

    get playButtonId() {
      return "control__btn--".concat(this.args.id);
    }

    get videoCoverTime() {
      if (this.args.thumbOffset) {
        // The BE code moves the offset back by 500ms when the offset is set to the end of the video.
        if (Math.floor(this.args.postMediaItem.videoDuration) < this.args.thumbOffset / 1000 + 0.5) {
          return this.args.postMediaItem.videoDuration - 0.5;
        }

        return this.args.postMediaItem.startTime + this.args.thumbOffset / 1000;
      }

      return this.videoStartTime;
    }

    willDestroy() {
      super.willDestroy(...arguments);

      if (this.canvasVideoPlayer) {
        if (this.canvasVideoPlayer.animationFrame) {
          cancelAnimationFrame(this.canvasVideoPlayer.animationFrame);
        }

        this.canvasVideoPlayer.unbind();
      }
    }

    handleInsert() {
      this.video = document.getElementById(this.videoId);
      this.canvas = document.getElementById(this.canvasId);
    }

    handleUpdate() {
      if (this.canvasVideoPlayer) {
        const options = {
          cropArray: this.args.cropArray,
          startTime: this.videoStartTime,
          endTime: this.videoEndTime,
          coverTime: this.videoCoverTime
        };
        this.canvasVideoPlayer.setup(options);
        this.canvasVideoPlayer.init();
      }
    }

    handleMediaClick() {
      return this.args.onMediaClick ? this.args.onMediaClick() : false;
    }

    playVideo() {
      var _this$canvasVideoPlay;

      (_this$canvasVideoPlay = this.canvasVideoPlayer) === null || _this$canvasVideoPlay === void 0 ? void 0 : _this$canvasVideoPlay.play();
    }

    pauseVideo() {
      var _this$canvasVideoPlay2;

      (_this$canvasVideoPlay2 = this.canvasVideoPlayer) === null || _this$canvasVideoPlay2 === void 0 ? void 0 : _this$canvasVideoPlay2.pause();
    }

    toggleVideo() {
      this._toggleVideo.perform();
    }

    *onLoadedMeta() {
      try {
        if (!this.isLoaded) {
          this.isLoaded = true;
          yield this._validateVideoDimensions.perform();

          this._createPlayer();
        }
      } catch (adapterError) {
        this.errors.handleAdapter(adapterError, this.args.postMediaItem);
      }
    }

    *_toggleVideo() {
      var _this$canvasVideoPlay3;

      const delay = 250;
      yield (0, _emberConcurrency.timeout)(delay);
      (_this$canvasVideoPlay3 = this.canvasVideoPlayer) === null || _this$canvasVideoPlay3 === void 0 ? void 0 : _this$canvasVideoPlay3.playPause();
    }

    *_validateVideoDimensions() {
      const {
        videoHeight,
        videoWidth
      } = this.video;

      if (!videoHeight || !videoWidth) {
        return;
      }

      const mediaItem = yield (0, _objectPromiseProxy.default)(this.mediaItem);

      if (videoHeight !== this.videoHeight || videoWidth !== this.videoWidth) {
        mediaItem.setProperties({
          width: videoWidth,
          height: videoHeight
        });
        return yield mediaItem.save();
      }

      return mediaItem;
    }

    _createPlayer() {
      var _this$canvasVideoPlay4, _this$canvasVideoPlay5;

      let width = 0;
      let height = 0;

      if (this.args.cropArray && this.args.cropArray.length) {
        const [x1, y1, x2, y2] = this.args.cropArray;
        width = x2 - x1;
        height = y2 - y1;
      } else {
        width = this.video.videoWidth;
        height = this.video.videoHeight;
        this.canvas.setAttribute('width', '100%');
        this.canvas.setAttribute('height', height);
      }

      (_this$canvasVideoPlay4 = this.canvasVideoPlayer) === null || _this$canvasVideoPlay4 === void 0 ? void 0 : _this$canvasVideoPlay4.unbind();
      const options = {
        videoSelector: "#".concat(this.videoId),
        canvasSelector: "#".concat(this.canvasId),
        timelineSelector: this.args.timeline ? "#".concat(this.timelineId) : false,
        playButtonSelector: "#".concat(this.playButtonId),
        cropArray: this.args.cropArray,
        startTime: this.videoStartTime,
        endTime: this.videoEndTime,
        coverTime: this.videoCoverTime
      };
      const player = new _canvasVideoPlayer.default(options);
      this.canvasVideoPlayer = player;

      if (!this.canvasVideoPlayer) {
        throw new Error('Video player canvas failed to initialize.');
      }

      const scalingFactor = this._scaleWithBoxSizing(width, height, this.args.maxWidth, this.args.maxHeight);

      (_this$canvasVideoPlay5 = this.canvasVideoPlayer) === null || _this$canvasVideoPlay5 === void 0 ? void 0 : _this$canvasVideoPlay5.setCanvasSize(width * scalingFactor, height * scalingFactor);
    }

    _scaleWithBoxSizing(width, height) {
      let boxWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
      let boxHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 300;

      if (width > boxWidth || height > boxHeight) {
        const scaleX = boxWidth / width;
        const scaleY = boxHeight / height;
        return Math.min(scaleX, scaleY);
      }

      return 1;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "video", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "canvas", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "canvasVideoPlayer", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isLoaded", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleInsert", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleMediaClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMediaClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "playVideo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "playVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pauseVideo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "pauseVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleVideo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onLoadedMeta", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "onLoadedMeta"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_toggleVideo", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "_toggleVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_validateVideoDimensions", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "_validateVideoDimensions"), _class.prototype)), _class);
  _exports.default = VideoPlayer;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, VideoPlayer);
});